import React from 'react'

export default function Topbar() {
    return (
        <nav className="double-nav top-nav-collapse navbar fixed-top navbar-expand-md navbar-dark scrolling-navbar indigo">
        <div className="logo-wrapper winter-neva-gradient z-depth-1-half rounded ">
            <a href="login.html"><img src="./img/waari-logo.png" width="540px" height="473px" className="img-fluid" alt="Responsive image" /></a>
        </div>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent-3" aria-controls="navbarSupportedContent-3" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon" />
        </button>
        <div className="collapse navbar-collapse">
            <ul className="navbar-nav ml-auto nav-flex-icons">
                <li className="nav-item mr-1">
                    <a className="nav-link" href="card-block.html" data-toggle="tooltip" title="Card Block">
                        <i className="fas fa-credit-card" />
                    </a>
                </li>
                <li className="nav-item mx-1">
                    <a className="nav-link" href="notification.html" data-toggle="tooltip" title="Notification">
                        <i className="fas fa-bell" />
                    </a>
                </li>
                <li className="nav-item mx-1">
                    <a className="nav-link" href="profile.html" data-toggle="tooltip" title="Profile">
                        <i className="fas fa-user" />
                    </a>
                </li>
                <li className="nav-item ml-1">
                    <a className="nav-link" href="login.html" data-toggle="tooltip" title="Log Out">
                        <i className="fas fa-power-off" />
                    </a>
                </li>
            </ul>
        </div>
    </nav>

    )
}
